/** Mean solve time for uniform 256-bit hashes at the observed throughput. */
export function estimateMiningTimeMs(targetExclusive: string | null, hashesPerSecond: number | null): number | null {
  if (targetExclusive === null || !/^[1-9][0-9]*$/.test(targetExclusive) ||
    hashesPerSecond === null || !Number.isFinite(hashesPerSecond) || hashesPerSecond <= 0) return null;
  const target = BigInt(targetExclusive);
  const hashSpace = 1n << 256n;
  if (target >= hashSpace) return null;
  // Preserve the uint256 target as bigint; only convert the resulting duration.
  const scaledRate = Math.round(hashesPerSecond * 1_000_000);
  if (!Number.isSafeInteger(scaledRate) || scaledRate <= 0) return null;
  const milliseconds = hashSpace * 1_000_000_000n / (target * BigInt(scaledRate));
  return milliseconds > BigInt(Number.MAX_SAFE_INTEGER) ? Infinity : Number(milliseconds);
}
